import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTitle } from '../../../context/TitleContext';
import { motion } from 'framer-motion';
import { FaArrowLeft, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const PharmacyBranchRequestDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { setTitle } = useTitle();
    const [request, setRequest] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [showImageModal, setShowImageModal] = useState(false);
    const [modalImageIndex, setModalImageIndex] = useState(0);

    useEffect(() => {
        setTitle('تفاصيل طلب الفرع');
        fetchRequestDetails();
    }, [setTitle, id]);

    const getAuthToken = () => {
        const storeData = sessionStorage.getItem('storekhadamat');
        if (storeData) {
            try {
                const parsed = JSON.parse(storeData);
                return parsed.token;
            } catch (error) {
                return null;
            }
        }
        return null;
    };

    const nextImage = () => {
        if (request.images && request.images.length > 0) {
            setCurrentImageIndex((prev) =>
                prev === request.images.length - 1 ? 0 : prev + 1
            );
        }
    };

    const prevImage = () => {
        if (request.images && request.images.length > 0) {
            setCurrentImageIndex((prev) =>
                prev === 0 ? request.images.length - 1 : prev - 1
            );
        }
    };

    const openImageModal = (index) => {
        setModalImageIndex(index);
        setShowImageModal(true);
    };

    const closeImageModal = () => {
        setShowImageModal(false);
    };

    const nextModalImage = () => {
        if (request && request.images) {
            setModalImageIndex((prevIndex) =>
                prevIndex === request.images.length - 1 ? 0 : prevIndex + 1
            );
        }
    };

    const prevModalImage = () => {
        if (request && request.images) {
            setModalImageIndex((prevIndex) =>
                prevIndex === 0 ? request.images.length - 1 : prevIndex - 1
            );
        }
    };

    // دالة للحصول على لون ونص الحالة
    const getStatusInfo = (status) => {
        const statusMap = {
            'approved': {
                class: 'bg-success',
                text: 'موافق عليه'
            },
            'rejected': {
                class: 'bg-danger',
                text: 'مرفوض'
            },
            'pending': {
                class: 'bg-warning',
                text: 'في الانتظار'
            },
            'doctor_responded': {
                class: 'bg-info',
                text: 'رد الصيدلية'
            },
            'under_review': {
                class: 'bg-secondary',
                text: 'قيد المراجعة'
            },
            'completed': {
                class: 'bg-success',
                text: 'مكتمل'
            },
            'cancelled': {
                class: 'bg-dark',
                text: 'ملغي'
            }
        };

        return statusMap[status] || {
            class: 'bg-light text-dark',
            text: status || 'غير محدد'
        };
    };

    const fetchRequestDetails = async () => {
        try {
            setLoading(true);
            const token = getAuthToken();

            if (!token) {
                toast.error('لا يوجد token للمصادقة');
                return;
            }

            const response = await axios.get(`${BASE_URL}/pharmacy/main-branch-requests/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept-Language': 'ar',
                    'lang': 'ar',
                },
            });


            if (response.data.status === 200 || response.data.status === 'success') {
                setRequest(response.data.data);
            } else {
                throw new Error(response.data.message || 'فشل في جلب تفاصيل الطلب');
            }
        } catch (error) {
            setError(error.response?.data?.message || error.message || 'فشل في جلب تفاصيل الطلب');
            toast.error(error.response?.data?.message || error.message || 'فشل في جلب تفاصيل الطلب');
        } finally {
            setLoading(false);
        }
    };


    if (loading) {
        return (
            <div className="main_content">
                <div className="dashboard-container">
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">جاري التحميل...</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (error || !request) {
        return (
            <div className="main_content">
                <div className="dashboard-container">
                    <div className="text-center py-5">
                        <div className="alert alert-danger">
                            <h4>خطأ</h4>
                            <p>{error || 'لم يتم العثور على الطلب'}</p>
                            <button
                                className="btn btn-primary"
                                onClick={() => navigate('/pharmacy-branch-requests')}
                            >
                                العودة للقائمة
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="main_content">
            <div className="dashboard-container">
                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="d-flex align-items-center gap-3">
                        <button
                            className="btn btn-outline-secondary"
                            onClick={() => navigate('/pharmacy-branch-requests')}
                            style={{ borderRadius: '8px' }}>
                            <FaArrowLeft className="mx-2" />
                            العودة
                        </button>
                        <h2 className="mb-0" style={{ fontSize: '20px' }}>تفاصيل طلب الفرع</h2>
                    </div>

                </div>

                {/* Request Details */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    className="card shadow-sm"
                    style={{ borderRadius: '12px' }}>

                    <div className="card-body p-4">
                        <div className="row">
                            {/* Basic Information */}
                            <div className="col-md-6 mb-4">
                                <h5 className="mb-3" style={{ color: '#184194' }}>المعلومات الأساسية</h5>
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">اسم العميل:</label>
                                    <p className="form-control-plaintext">{request.client?.name || (typeof request.client === 'string' ? request.client : 'غير محدد')}</p>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">رقم هاتف العميل:</label>
                                    <p className="form-control-plaintext">
                                        {request.phone ? (
                                            <a href={`tel:${request.phone}`} className="text-decoration-none" style={{ color: '#184194' }}>
                                                {request.phone}
                                            </a>
                                        ) : (
                                            'غير محدد'
                                        )}
                                    </p>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">رقم الطلب:</label>
                                    <p className="form-control-plaintext">{request.id || 'غير محدد'}</p>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">تاريخ الإنشاء:</label>
                                    <p className="form-control-plaintext">
                                        {request.created_at ? new Date(request.created_at).toLocaleDateString('ar-EG') : 'غير محدد'}
                                    </p>
                                </div>
                            </div>

                            {/* Status and Branch Info */}
                            <div className="col-md-6 mb-4">
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">الحالة:</label>
                                    <div>
                                        {(() => {
                                            const statusInfo = getStatusInfo(request.status);
                                            return (
                                                <span className={`badge ${statusInfo.class}`} style={{ color: 'white' }}>
                                                    {statusInfo.text}
                                                </span>
                                            );
                                        })()}
                                    </div>
                                </div>

                            </div>
                        </div>

                        {/* Branch Information Section */}
                        {request.branch && (
                            <div className="row mb-4">
                                <div className="col-12">
                                    <h5 className="mb-3" style={{ color: '#184194' }}>معلومات الفرع</h5>
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label fw-semibold">اسم الفرع:</label>
                                            <p className="form-control-plaintext">{request.branch.market_name || 'غير محدد'}</p>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label fw-semibold">هاتف الفرع:</label>
                                            <p className="form-control-plaintext">{request.branch.phone || 'غير محدد'}</p>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label fw-semibold">البريد الإلكتروني:</label>
                                            <p className="form-control-plaintext">{request.branch.email || 'غير محدد'}</p>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label fw-semibold">العنوان:</label>
                                            <p className="form-control-plaintext">{request.branch.address || 'غير محدد'}</p>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <label className="form-label fw-semibold">الموقع على الخريطة:</label>
                                            {request.branch.lat && request.branch.lng ? (
                                                <>
                                                    <div style={{ height: '350px', borderRadius: '8px', overflow: 'hidden', border: '2px solid #e9ecef', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                                                        <iframe
                                                            title="موقع الفرع"
                                                            width="100%"
                                                            height="100%"
                                                            frameBorder="0"
                                                            style={{ border: 0 }}
                                                            src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyAHQSuklfkVa-mATYvbA7odk3_LpnKG-OA&q=${parseFloat(request.branch.lat).toFixed(7)},${parseFloat(request.branch.lng).toFixed(7)}&zoom=18&language=ar`}
                                                            allowFullScreen>
                                                        </iframe>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center mt-2">
                                                        <small className="text-muted">
                                                            <i className="fas fa-map-marker-alt mx-1"></i>
                                                            الإحداثيات: {parseFloat(request.branch.lat).toFixed(7)}, {parseFloat(request.branch.lng).toFixed(7)}
                                                        </small>
                                                        <a
                                                            href={`https://www.google.com/maps?q=${parseFloat(request.branch.lat).toFixed(7)},${parseFloat(request.branch.lng).toFixed(7)}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="btn btn-sm text-white"
                                                            style={{ backgroundColor: '#184194' }}
                                                        >
                                                            <i className="fas fa-external-link-alt mx-1"></i>
                                                            فتح في Google Maps
                                                        </a>
                                                    </div>
                                                </>
                                            ) : (
                                                <p className="text-muted">غير محدد</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Images Section */}
                        {request.images && request.images.length > 0 && (
                            <div className="row mb-4">
                                <div className="col-12">
                                    <h5 className="mb-3" style={{ color: '#184194' }}>صور الطلب</h5>

                                    {/* Main Image Display */}
                                    <div className="position-relative mb-3">
                                        <img
                                            src={request.images[currentImageIndex]}
                                            alt={`صورة ${currentImageIndex + 1}`}
                                            style={{
                                                width: '100%',
                                                height: '300px',
                                                objectFit: 'cover',
                                                borderRadius: '12px',
                                                border: '2px solid #f0f0f0',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => openImageModal(currentImageIndex)}
                                        />

                                        {/* Navigation Arrows */}
                                        {request.images.length > 1 && (
                                            <>
                                                <button
                                                    className="btn btn-light position-absolute top-50 start-0 translate-middle-y"
                                                    style={{
                                                        borderRadius: '50%',
                                                        width: '40px',
                                                        height: '40px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                                                    }}
                                                    onClick={prevImage}>
                                                    <FaChevronLeft />
                                                </button>
                                                <button
                                                    className="btn btn-light position-absolute top-50 end-0 translate-middle-y"
                                                    style={{
                                                        borderRadius: '50%',
                                                        width: '40px',
                                                        height: '40px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                                                    }}
                                                    onClick={nextImage}>
                                                    <FaChevronRight />
                                                </button>
                                            </>
                                        )}
                                    </div>

                                    {/* Thumbnail Images */}
                                    {request.images.length > 1 && (
                                        <div className="d-flex gap-2 justify-content-center flex-wrap">
                                            {request.images.map((image, index) => (
                                                <img
                                                    key={index}
                                                    src={image}
                                                    alt={`صورة ${index + 1}`}
                                                    style={{
                                                        width: '80px',
                                                        height: '80px',
                                                        objectFit: 'cover',
                                                        borderRadius: '8px',
                                                        border: currentImageIndex === index ? '3px solid #184194' : '2px solid #ddd',
                                                        cursor: 'pointer',
                                                        opacity: currentImageIndex === index ? 1 : 0.7
                                                    }}
                                                    onClick={() => {
                                                        setCurrentImageIndex(index);
                                                        openImageModal(index);
                                                    }}
                                                />
                                            ))}
                                        </div>
                                    )}

                                    {/* Image Counter */}
                                    <div className="text-center mt-2">
                                        <small className="text-muted">
                                            {currentImageIndex + 1} من {request.images.length}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Items Section */}
                        {request.items && request.items.length > 0 && (
                            <div className="row mb-4">
                                <div className="col-12">
                                    <h5 className="mb-3" style={{ color: '#184194' }}>منتجات الطلب</h5>
                                    <div className="table-responsive">
                                        <table className="table table-hover">
                                            <thead>
                                                <tr style={{ backgroundColor: 'transparent' }}>
                                                    <th className="border-0 fw-semibold text-center">#</th>
                                                    <th className="border-0 fw-semibold text-end">اسم المنتج</th>
                                                    <th className="border-0 fw-semibold text-center">اسم الوحدة</th>
                                                    <th className="border-0 fw-semibold text-center">سعر الوحدة</th>
                                                    <th className="border-0 fw-semibold text-center">الكمية</th>
                                                    <th className="border-0 fw-semibold text-center">نسبة الخصم</th>
                                                    <th className="border-0 fw-semibold text-center">السعر النهائي</th>
                                                    <th className="border-0 fw-semibold text-center">المجموع</th>
                                                    <th className="border-0 fw-semibold text-center">الملاحظات</th>
                                                    <th className="border-0 fw-semibold text-center">الحالة</th>
                                                </tr>
                                            </thead>
                                            <tbody style={{ backgroundColor: 'transparent' }}>
                                                {request.items.map((item, index) => (
                                                    <tr key={index} style={{ backgroundColor: 'transparent !important' }}>
                                                        <td className="border-0 text-center" style={{ backgroundColor: 'transparent' }}>
                                                            <span className="fw-semibold text-muted">#{index + 1}</span>
                                                        </td>
                                                        <td className="border-0" style={{ backgroundColor: 'transparent' }}>
                                                            <div className="text-end">
                                                                <h6 className="mb-0 fw-semibold">{item.product_name || 'غير محدد'}</h6>
                                                            </div>
                                                        </td>
                                                        <td className="border-0 text-center" style={{ backgroundColor: 'transparent' }}>
                                                            {item.unit_name ? (
                                                                <span className="badge bg-light text-dark">{item.unit_name}</span>
                                                            ) : (
                                                                <span className="text-muted">غير محدد</span>
                                                            )}
                                                        </td>
                                                        <td className="border-0 text-center" style={{ backgroundColor: 'transparent' }}>
                                                            <span className="fw-semibold">{item.unit_price || 0} ج.م</span>
                                                        </td>
                                                        <td className="border-0 text-center" style={{ backgroundColor: 'transparent' }}>
                                                            <span className="fw-semibold">{item.quantity || '0'}</span>
                                                        </td>
                                                        <td className="border-0 text-center" style={{ backgroundColor: 'transparent' }}>
                                                            {item.discount_pct && item.discount_pct > 0 ? (
                                                                <span className="badge bg-warning text-dark">{item.discount_pct}%</span>
                                                            ) : (
                                                                <span className="text-muted">0%</span>
                                                            )}
                                                        </td>
                                                        <td className="border-0 text-center" style={{ backgroundColor: 'transparent' }}>
                                                            <span className="fw-semibold text-success">{item.final_price || '0'} ج.م</span>
                                                        </td>
                                                        <td className="border-0 text-center" style={{ backgroundColor: 'transparent' }}>
                                                            <span className="fw-semibold text-primary">{item.line_total || '0'} ج.م</span>
                                                        </td>
                                                        <td className="border-0 text-center" style={{ backgroundColor: 'transparent' }}>
                                                            {item.note ? (
                                                                <span className="text-muted" style={{
                                                                    backgroundColor: '#f8f9fa',
                                                                    padding: '4px 8px',
                                                                    borderRadius: '4px',
                                                                    display: 'inline-block',
                                                                    fontSize: '11px'
                                                                }}>
                                                                    📝 {item.note}
                                                                </span>
                                                            ) : (
                                                                <span className="text-muted">لا توجد ملاحظات</span>
                                                            )}
                                                        </td>
                                                        <td className="border-0 text-center" style={{ backgroundColor: 'transparent' }}>
                                                            {(() => {
                                                                const statusInfo = getStatusInfo(item.status);
                                                                return (
                                                                    <span className={`badge ${statusInfo.class}`} style={{ color: 'white' }}>
                                                                        {statusInfo.text}
                                                                    </span>
                                                                );
                                                            })()}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Order Summary */}
                        {request.grand_total !== undefined && (
                            <div className="row mb-4">
                                <div className="col-12">
                                    <h5 className="mb-3" style={{ color: '#184194' }}>ملخص الطلب</h5>
                                    <div className="alert alert-success">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span className="fw-semibold">المجموع الكلي:</span>
                                            <span className="fw-bold" style={{ fontSize: '18px', color: '#28a745' }}>
                                                {request.grand_total} ج.م
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Notes */}
                        {request.note && (
                            <div className="row">
                                <div className="col-12">
                                    <h5 className="mb-3" style={{ color: '#184194' }}>ملاحظات العميل</h5>
                                    <div className="alert alert-info">
                                        <p className="mb-0">{request.note}</p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </motion.div>
            </div>

            {/* Image Modal */}
            {showImageModal && request && request.images && (
                <div
                    className="modal fade show d-block"
                    style={{ backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 9999 }}
                    onClick={closeImageModal}
                >
                    <div className="modal-dialog modal-xl modal-dialog-centered">
                        <div className="modal-content" style={{ backgroundColor: 'transparent', border: 'none' }}>
                            <div className="modal-header border-0 justify-content-end">
                                <button
                                    type="button"
                                    className="btn-close btn-close-white"
                                    onClick={closeImageModal}
                                    style={{ fontSize: '1.5rem' }}
                                ></button>
                            </div>
                            <div className="modal-body text-center">
                                <div className="position-relative d-inline-block">
                                    <img
                                        src={request.images[modalImageIndex]}
                                        alt={`Request Image ${modalImageIndex + 1}`}
                                        className="img-fluid"
                                        style={{
                                            maxHeight: '80vh',
                                            maxWidth: '90vw',
                                            borderRadius: '12px',
                                            boxShadow: '0 8px 32px rgba(0,0,0,0.3)'
                                        }}
                                    />

                                    {request.images.length > 1 && (
                                        <>
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    prevModalImage();
                                                }}
                                                className="btn btn-light position-absolute"
                                                style={{
                                                    top: '50%',
                                                    left: '20px',
                                                    transform: 'translateY(-50%)',
                                                    borderRadius: '50%',
                                                    width: '50px',
                                                    height: '50px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                                                    zIndex: 10000
                                                }}
                                            >
                                                <FaChevronLeft style={{ color: '#184194', fontSize: '18px' }} />
                                            </button>
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    nextModalImage();
                                                }}
                                                className="btn btn-light position-absolute"
                                                style={{
                                                    top: '50%',
                                                    right: '20px',
                                                    transform: 'translateY(-50%)',
                                                    borderRadius: '50%',
                                                    width: '50px',
                                                    height: '50px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                                                    zIndex: 10000
                                                }}
                                            >
                                                <FaChevronRight style={{ color: '#184194', fontSize: '18px' }} />
                                            </button>
                                        </>
                                    )}

                                    {request.images.length > 1 && (
                                        <div
                                            className="position-absolute"
                                            style={{
                                                bottom: '-40px',
                                                left: '50%',
                                                transform: 'translateX(-50%)',
                                                backgroundColor: 'rgba(0,0,0,0.7)',
                                                color: 'white',
                                                padding: '8px 16px',
                                                borderRadius: '20px',
                                                fontSize: '14px',
                                                fontWeight: '600'
                                            }}
                                        >
                                            {modalImageIndex + 1} / {request.images.length}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PharmacyBranchRequestDetails;
